import { CameraPosition } from '@/api/controlUnitApi/types.gen'
import { Rectangle } from './types'

const translateCamera = (camera: 'Front Left' | 'Front Center' | 'Front Right') => {
  if (camera === 'Front Left') return 'FL'
  if (camera === 'Front Center') return 'FC'
  if (camera === 'Front Right') return 'FR'
  return 'FL'
}

const translateCameraPosition = (camera: CameraPosition) => {
  if (camera === 'FL') return 'Front Left'
  if (camera === 'FC') return 'Front Center'
  if (camera === 'FR') return 'Front Right'
  return 'Front Left'
}

const translateToNaturalScale = (displayedRectangle: Rectangle, imageElement: HTMLImageElement): Rectangle => {
  const scaleX = imageElement.naturalWidth / imageElement.offsetWidth
  const scaleY = imageElement.naturalHeight / imageElement.offsetHeight

  return {
    ...displayedRectangle,
    x: Math.round(displayedRectangle.x * scaleX),
    y: Math.round(displayedRectangle.y * scaleY),
    width: Math.round(displayedRectangle.width * scaleX),
    height: Math.round(displayedRectangle.height * scaleY),
  }
}

export { translateCamera, translateCameraPosition, translateToNaturalScale }
